const format = (prefix, message) => {
  const text = typeof message === "string" ? message : JSON.stringify(message);
  return `${prefix}${text}`;
};

const toast = (message) => {
  if (typeof window !== "undefined" && window.console) {
    console.log(format("ℹ️ ", message));
  }
};

toast.success = (message) => {
  if (typeof window !== "undefined" && window.console) {
    console.log(format("✅ ", message));
  }
};

toast.error = (message) => {
  if (typeof window !== "undefined" && window.console) {
    console.error(format("❌ ", message));
  }
};

toast.promise = (promise, { loading, success, error }) => {
  if (typeof window !== "undefined" && window.console && loading) {
    console.log(format("⏳ ", loading));
  }
  return promise
    .then((result) => {
      toast.success(success);
      return result;
    })
    .catch((err) => {
      toast.error(error);
      throw err;
    });
};

export function Toaster() {
  return null;
}

export default toast;
